import { render, staticRenderFns } from "./XFilesItemEdit.vue?vue&type=template&id=52772d8c"
import script from "./XFilesItemEdit.vue?vue&type=script&lang=js"
export * from "./XFilesItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports